import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {FormGroup,FormBuilder} from '@angular/forms';
import * as moment from 'moment';

@Component({
  selector: 'app-form-filter',
  templateUrl: './form-filter.component.html',
  styleUrls: ['./form-filter.component.scss']
})
export class FormFilterComponent implements OnInit {

  @Output() closeFilter = new EventEmitter<any>()
  selected: any;
  alwaysShowCalendars: boolean;
  showRangeLabelOnInput: boolean;
  keepCalendarOpeningWithRange: boolean;
  maxDate: moment.Moment;
  minDate: moment.Moment;
  invalidDates: moment.Moment[] = [];
  myFormGroup: FormGroup;
  fileType:any="";
  filterByDate:any="";
  Filters:any={};
  // tooltips = [
  //   {date: moment(), text: 'Today is just unselectable'},
  //   {date:  moment().add(2, 'days'), text: '2 days'}
  // ];
  inlineDateTime;
  ranges = {
    Today: [moment(), moment()],
    'This Week': [moment().startOf('week'), moment().endOf('week')],
    'Last Week': [moment().subtract(1, 'week').startOf('week'), moment().subtract(1, 'week').endOf('week')],
    'This Month': [moment().startOf('month'), moment().endOf('month')],
    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')]
  };
  fileTypes:any=[];
  startDate:any;
  endDate:any; 
  showApplyButton:boolean=false;

  constructor(private formBuilder: FormBuilder) {
    this.alwaysShowCalendars = true;
    this.keepCalendarOpeningWithRange = true;
    this.showRangeLabelOnInput = true;
   
    this.fileTypes=[{value:1,name:'PDF'}];
   // this.fileTypes=[{value:0,name:'HTML'},{value:1,name:'PDF'},{value:2,name:'Both'}];
  }

  ngOnInit() {
    let group = {};
    this.myFormGroup = this.formBuilder.group({
      FileType: "",
      FilterColType: "",
      dateRange:""
    });
  }

  fileTypeSelection(event){
    this.showApplyButton=true;
    this.fileType = event.value;     
  }

  dateTypeSelection(event){
  this.filterByDate = event.value;     
  }

  rangeClicked(range) {
    if (!(range.startDate == null && range.endDate == null)) {
      this.startDate=moment(range.startDate).format("MM/DD/YYYY");
      this.endDate=moment(range.endDate).format("MM/DD/YYYY");
    }
  }

  datesUpdated(range) {
    if (!(range.startDate == null && range.endDate == null)) {
      this.startDate=moment(range.startDate).format("MM/DD/YYYY");
      this.endDate=moment(range.endDate).format("MM/DD/YYYY");
    }
  } 

  choosedDateTime(e) {
    this.inlineDateTime = e;
  }

  clearAllClick() {
    this.showApplyButton=false;
    this.myFormGroup.reset();
    this.fileType="";
    this.filterByDate="";
    this.closeFilterSilde(false);
  }

  closeFilterSilde(message) {
    if(message){
      let filtersSelectd={
        fileType:this.fileType,
        filterByDate:this.filterByDate,
        startDate:this.startDate,
        endDate:this.endDate
      }
      this.closeFilter.emit(filtersSelectd);   
      this.showApplyButton=false;
      this.myFormGroup.reset();
      this.fileType="";
      this.filterByDate="";
    }
    else{
    this.closeFilter.emit(message);
    this.showApplyButton=false;
    this.myFormGroup.reset();
    this.fileType="";
    this.filterByDate="";
    }
  }

}
